export default __webpack_public_path__ + "static/media/exhibition.5d7153aa.webp";